import axios from 'axios';

import { headers, STOCK } from '../../config';

function create(data) {
    return axios.post(`${STOCK}/items/${data.item_id}/measure-units/${data.measure_unit_id}`, data, { headers: {
        ...headers(),
        "X-Request-ID": data.idempotentKey
    } })
}

function findByID({itemId, measureUnitId}) {
    return axios.get(`${STOCK}/items/${itemId}/measure-units/${measureUnitId}`, { headers: headers() })
}

function update(data){
    return axios.put(`${STOCK}/items/${data.item_id}/measure-units/${data.measure_unit_id}`, data, { headers: headers() })
}

function remove({itemId, measureUnitId}) {
    return axios.delete(`${STOCK}/items/${itemId}/measure-units/${measureUnitId}`, { headers: headers() })
}

export default {
    create,
    findByID,
    update,
    remove
}